import { parseResponseError } from "../Utils/errorUtils";
import axiosInstance from "../Utils/axiosInstance";

/**
 * a global function for post api call
 * @param {*} path
 * @param {*} data
 * @returns
 */
export const postCall = async (path, data) => {
  try {
    let response = await axiosInstance.post(`${path}`, data);
    return response.data;
  } catch (error) {
    return parseResponseError(error);
  }
};
